import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-target"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Open Modal")
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Modal Title")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  id: "modalAddClose",
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Modal Body")
const _hoisted_12 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "openButton", {
      id: `openButton${_ctx.id}`,
      "data-Toggle": 'modal',
      "data-Target": `#${_ctx.id}`
    }, () => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        "data-toggle": "modal",
        "data-target": `#${_ctx.id}`
      }, [
        _renderSlot(_ctx.$slots, "buttonText", {}, () => [
          _hoisted_2
        ])
      ], 8, _hoisted_1)
    ]),
    _createElementVNode("div", {
      class: "modal",
      tabindex: "-1",
      role: "dialog",
      id: `${_ctx.id}`
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _hoisted_8
              ])
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "modalBody", {}, () => [
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _renderSlot(_ctx.$slots, "modalFooter"),
            (_ctx.showCancel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-red",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  ref: "closeButton"
                }, _toDisplayString(_ctx.$t("messages.Cancel")), 513))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 8, _hoisted_3)
  ], 64))
}